'1
<template>
  <div class="ub ub-ver fw">
    <template v-if="dataSource?.length > 0">
      <flow-item
        :isFirst="index == 0"
        :isBottom="index == dataSource?.length - 1"
        v-for="(item, index) in dataSource"
        :key="index"
        :item="item"
      ></flow-item>
    </template>
    <a-empty :image="simpleImage" v-else>
      <template #description>暂无数据</template>
    </a-empty>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import FlowItem from "./flow-item.vue";
import { Empty } from "ant-design-vue";

export default defineComponent({
  isGlobal: true,
  name: "CollaborationLogTable",
  components: { FlowItem },
  props: {
    value: {
      type: Object,
    },
    bizId: {
      type: String,
      required: true,
    },
    bizType: {
      type: String,
      required: true,
    },
    eventName: {
      type: String,
    },
  },
  emits: ["refresh"],
  setup(props, { emit }) {
    onMounted(async () => {});
    const dataSource = ref([]);
    watch(
      () => props.value,
      (n: any, o) => {
        if (n) {
          dataSource.value = n;
        }
      }
    );
    return {
      dataSource,
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
    };
  },
});
</script>

<style scoped lang="less"></style>
